import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  makeStyles,
  Theme,
  Tooltip,
  Chip,
} from '@material-ui/core';
import { formatCurrency } from '@roc/ui/utils';
import { Error } from '@material-ui/icons';

export interface FieldReviewRow {
  itemName?: string;
  itemDisplayName?: string;
  data?: string | number | null;
  expectedData?: string | number | null;
  needsRevisionFlag?: boolean;
}

export interface FieldReviewTableProps {
  items?: FieldReviewRow[];
}

const useStyles = makeStyles((theme: Theme) => ({
  headCell: {
    color: theme.palette.text.secondary,
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    backgroundColor: '#FAFAFA',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  headMatchCell: {
    backgroundColor: '#FAFAFA',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    textAlign: 'center',
    width: '5%',
  },
  labelCell: {
    width: '40%',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  valueCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  matchCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    textAlign: 'center',
    width: '5%',
  },
  lastRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
  chipYes: {
    backgroundColor: '#BEE3C0',
    color: theme.palette.success.dark,
    borderRadius: '16px',
    fontWeight: 500,
  },
  chipNo: {
    backgroundColor: '#E0E0E0',
    color: theme.palette.text.primary,
    borderRadius: '16px',
    fontWeight: 500,
  },
}));

export const FieldReviewTable = ({ items }: FieldReviewTableProps) => {
  const classes = useStyles();
  const formatValue = (key: any, value: any) => {
    if (value === null || value === undefined || value === '') return '—';
    if (key === 'signature') {
        const isYes = value === true || value === 'true';
        return (
          <Chip
            size="small"
            label={isYes ? 'Yes' : 'No'}
            className={isYes ? classes.chipYes : classes.chipNo}
          />
        );
      }
    return typeof value === 'number' ? formatCurrency(value) : String(value);
  };
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell className={classes.headMatchCell} />
          <TableCell className={classes.headCell}>Field</TableCell>
          <TableCell className={classes.headCell}>Portal</TableCell>
          <TableCell className={classes.headCell}>Document</TableCell>
        </TableRow>
        {items.map((item, index) => (
          <TableRow
            key={item.itemName}
            className={index === items.length - 1 ? classes.lastRow : ''}
          >
            <TableCell className={classes.matchCell}>
              {item.needsRevisionFlag && (
                <Tooltip title="The extracted value does not match the expected value.">
                  <Error color="error" />
                </Tooltip>
              )}
            </TableCell>
            <TableCell className={classes.labelCell}>{item.itemDisplayName}</TableCell>
            <TableCell className={classes.valueCell}>{formatValue(item.itemName, item.expectedData)}</TableCell>
            <TableCell className={classes.valueCell}>{formatValue(item.itemName, item.data)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
